export * from "./getStripeDevicePaymentAvailable";
export * from "./initializeStripeDevicePaymentButton";
export * from "./vaultStripeDevicePaymentMethod";

export const customGooglePayButtonId = "stripe-payment-request-button";
